/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, eqeqeq: 0, no-cond-assign: 0, no-empty: 0, no-unused-expressions: 0, babel/no-unused-expressions: 0, no-use-before-define: 0, no-useless-escape: 0, no-var: 0 */
/* globals define, exports, module */

//  Underscore.string
//  (c) 2010 Esa-Matti Suuronen <esa-matti aet suuronen dot org>
//  Underscore.string is freely distributable under the terms of the MIT license.
//  Documentation: https://github.com/epeli/underscore.string
//  Some code is borrowed from MooTools and Alexandru Marasteanu.
//  Version '2.3.0'

(function(root, String) {
  'use strict';

  // Defining helper functions.

  var nativeTrim = String.prototype.trim;
  var nativeTrimRight = String.prototype.trimRight;
  var nativeTrimLeft = String.prototype.trimLeft;

  var parseNumber = function(source) { return source * 1 || 0; };

  var strRepeat = function(str, qty) {
    if (qty < 1) return ``;
    var result = ``;
    while (qty > 0) {
      if (qty & 1) result += str;
      qty >>= 1, str += str;
    }
    return result;
  };

  var slice = [].slice;

  var defaultToWhiteSpace = function(characters) {
    if (characters == null)
      return `\\s`;
    else if (characters.source)
      return characters.source;
    else
      return `[` + _s.escapeRegExp(characters) + `]`;
  };

  var escapeChars = {
    lt: `<`,
    gt: `>`,
    quot: `"`,
    apos: `'`,
    amp: `&`,
  };

  var reversedEscapeChars = {};
  for (var key in escapeChars) { reversedEscapeChars[escapeChars[key]] = key; }

  // sprintf() for JavaScript 0.7-beta1
  // http://www.diveintojavascript.com/projects/javascript-sprintf
  //
  // Copyright (c) Alexandru Marasteanu <alexaholic [at) gmail (dot] com>
  // All rights reserved.

  var sprintf = (function() {
    function get_type(variable) {
      return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase();
    }

    var str_repeat = strRepeat;

    var str_format = function() {
      if (!Object.prototype.hasOwnProperty.call(str_format.cache, arguments[0])) {
        str_format.cache[arguments[0]] = str_format.parse(arguments[0]);
      }
      return str_format.format.call(null, str_format.cache[arguments[0]], arguments);
    };

    str_format.format = function(parse_tree, argv) {
      var cursor = 1, tree_length = parse_tree.length, node_type = ``, arg, output = [], i, k, match, pad, pad_character, pad_length;
      for (i = 0; i < tree_length; i++) {
        node_type = get_type(parse_tree[i]);
        if (node_type === `string`) {
          output.push(parse_tree[i]);
        }
        else if (node_type === `array`) {
          match = parse_tree[i]; // convenience purposes only
          if (match[2]) { // keyword argument
            arg = argv[cursor];
            for (k = 0; k < match[2].length; k++) {
              if (!Object.prototype.hasOwnProperty.call(arg, match[2][k])) {
                throw new Error(sprintf(`[_.sprintf] property "%s" does not exist`, match[2][k]));
              }
              arg = arg[match[2][k]];
            }
          } else if (match[1]) { // positional argument (explicit)
            arg = argv[match[1]];
          }
          else { // positional argument (implicit)
            arg = argv[cursor++];
          }

          if (/[^s]/.test(match[8]) && (get_type(arg) != `number`)) {
            throw new Error(sprintf(`[_.sprintf] expecting number but found %s`, get_type(arg)));
          }
          switch (match[8]) {
            case `b`: arg = arg.toString(2); break;
            case `c`: arg = String.fromCharCode(arg); break;
            case `d`: arg = parseInt(arg, 10); break;
            case `e`: arg = match[7] ? arg.toExponential(match[7]) : arg.toExponential(); break;
            case `f`: arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg); break;
            case `o`: arg = arg.toString(8); break;
            case `s`: arg = ((arg = String(arg)) && match[7] ? arg.substring(0, match[7]) : arg); break;
            case `u`: arg = Math.abs(arg); break;
            case `x`: arg = arg.toString(16); break;
            case `X`: arg = arg.toString(16).toUpperCase(); break;
          }
          arg = (/[def]/.test(match[8]) && match[3] && arg >= 0 ? `+`+ arg : arg);
          pad_character = match[4] ? match[4] == `0` ? `0` : match[4].charAt(1) : ` `;
          pad_length = match[6] - String(arg).length;
          pad = match[6] ? str_repeat(pad_character, pad_length) : ``;
          output.push(match[5] ? arg + pad : pad + arg);
        }
      }
      return output.join(``);
    };

    str_format.cache = {};

    str_format.parse = function(fmt) {
      var _fmt = fmt, match = [], parse_tree = [], arg_names = 0;
      while (_fmt) {
        if ((match = /^[^\x25]+/.exec(_fmt)) !== null) {
          parse_tree.push(match[0]);
        }
        else if ((match = /^\x25{2}/.exec(_fmt)) !== null) {
          parse_tree.push(`%`);
        }
        else if ((match = /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosuxX])/.exec(_fmt)) !== null) {
          if (match[2]) {
            arg_names |= 1;
            var field_list = [], replacement_field = match[2], field_match = [];
            if ((field_match = /^([a-z_][a-z_\d]*)/i.exec(replacement_field)) !== null) {
              field_list.push(field_match[1]);
              while ((replacement_field = replacement_field.substring(field_match[0].length)) !== ``) {
                if ((field_match = /^\.([a-z_][a-z_\d]*)/i.exec(replacement_field)) !== null) {
                  field_list.push(field_match[1]);
                }
                else if ((field_match = /^\[(\d+)\]/.exec(replacement_field)) !== null) {
                  field_list.push(field_match[1]);
                }
                else {
                  throw new Error(`[_.sprintf] huh?`);
                }
              }
            }
            else {
              throw new Error(`[_.sprintf] huh?`);
            }
            match[2] = field_list;
          }
          else {
            arg_names |= 2;
          }
          if (arg_names === 3) {
            throw new Error(`[_.sprintf] mixing positional and named placeholders is not (yet) supported`);
          }
          parse_tree.push(match);
        }
        else {
          throw new Error(`[_.sprintf] huh?`);
        }
        _fmt = _fmt.substring(match[0].length);
      }
      return parse_tree;
    };

    return str_format;
  })();



  // Defining underscore.string

  var _s = {

    VERSION: `2.3.0`,

    isBlank(str) {
      if (str == null) str = ``;
      return (/^\s*$/).test(str);
    },

    stripTags(str) {
      if (str == null) return ``;
      return String(str).replace(/<\/?[^>]+>/g, ``);
    },

    capitalize(str) {
      str = str == null ? `` : String(str);
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    chop(str, step) {
      if (str == null) return [];
      str = String(str);
      step = ~~step;
      return step > 0 ? str.match(new RegExp(`.{1,` + step + `}`, `g`)) : [str];
    },

    clean(str) {
      return _s.strip(str).replace(/\s+/g, ` `);
    },

    count(str, substr) {
      if (str == null || substr == null) return 0;
      return String(str).split(substr).length - 1;
    },

    chars(str) {
      if (str == null) return [];
      return String(str).split(``);
    },

    swapCase(str) {
      if (str == null) return ``;
      return String(str).replace(/\S/g, function(c) {
        return c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase();
      });
    },

    escapeHTML(str) {
      if (str == null) return ``;
      return String(str).replace(/[&<>"']/g, function(m) { return `&` + reversedEscapeChars[m] + `;`; });
    },

    unescapeHTML(str) {
      if (str == null) return ``;
      return String(str).replace(/\&([^;]+);/g, function(entity, entityCode) {
        var match;

        if (entityCode in escapeChars) {
          return escapeChars[entityCode];
        } else if (match = entityCode.match(/^#x([\da-fA-F]+)$/)) {
          return String.fromCharCode(parseInt(match[1], 16));
        } else if (match = entityCode.match(/^#(\d+)$/)) {
          return String.fromCharCode(~~match[1]);
        } else {
          return entity;
        }
      });
    },

    escapeRegExp(str) {
      if (str == null) return ``;
      return String(str).replace(/([.*+?^=!:${}()|[\]\/\\])/g, `\\$1`);
    },

    splice(str, i, howmany, substr) {
      var arr = _s.chars(str);
      arr.splice(~~i, ~~howmany, substr);
      return arr.join(``);
    },

    insert(str, i, substr) {
      return _s.splice(str, i, 0, substr);
    },

    include(str, needle) {
      if (needle === ``) return true;
      if (str == null) return false;
      return String(str).indexOf(needle) !== -1;
    },

    join() {
      var args = slice.call(arguments),
        separator = args.shift();

      if (separator == null) separator = ``;

      return args.join(separator);
    },

    lines(str) {
      if (str == null) return [];
      return String(str).split(`\n`);
    },

    reverse(str) {
      return _s.chars(str).reverse().join(``);
    },

    startsWith(str, starts) {
      if (starts === ``) return true;
      if (str == null || starts == null) return false;
      str = String(str); starts = String(starts);
      return str.length >= starts.length && str.slice(0, starts.length) === starts;
    },

    endsWith(str, ends) {
      if (ends === ``) return true;
      if (str == null || ends == null) return false;
      str = String(str); ends = String(ends);
      return str.length >= ends.length && str.slice(str.length - ends.length) === ends;
    },

    succ(str) {
      if (str == null) return ``;
      str = String(str);
      return str.slice(0, -1) + String.fromCharCode(str.charCodeAt(str.length-1) + 1);
    },

    titleize(str) {
      if (str == null) return ``;
      return String(str).replace(/(?:^|\s)\S/g, function(c) { return c.toUpperCase(); });
    },

    camelize(str) {
      return _s.trim(str).replace(/[-_\s]+(.)?/g, function(match, c) { return c.toUpperCase(); });
    },

    underscored(str) {
      return _s.trim(str).replace(/([a-z\d])([A-Z]+)/g, `$1_$2`).replace(/[-\s]+/g, `_`).toLowerCase();
    },

    dasherize(str) {
      return _s.trim(str).replace(/([A-Z])/g, `-$1`).replace(/[-_\s]+/g, `-`).toLowerCase();
    },

    classify(str) {
      return _s.titleize(String(str).replace(/_/g, ` `)).replace(/\s/g, ``);
    },

    humanize(str) {
      return _s.capitalize(_s.underscored(str).replace(/_id$/, ``).replace(/_/g, ` `));
    },

    trim(str, characters) {
      if (str == null) return ``;
      if (!characters && nativeTrim) return nativeTrim.call(str);
      characters = defaultToWhiteSpace(characters);
      return String(str).replace(new RegExp(`\^` + characters + `+|` + characters + `+$`, `g`), ``);
    },

    ltrim(str, characters) {
      if (str == null) return ``;
      if (!characters && nativeTrimLeft) return nativeTrimLeft.call(str);
      characters = defaultToWhiteSpace(characters);
      return String(str).replace(new RegExp(`^` + characters + `+`), ``);
    },

    rtrim(str, characters) {
      if (str == null) return ``;
      if (!characters && nativeTrimRight) return nativeTrimRight.call(str);
      characters = defaultToWhiteSpace(characters);
      return String(str).replace(new RegExp(characters + `+$`), ``);
    },

    truncate(str, length, truncateStr) {
      if (str == null) return ``;
      str = String(str); truncateStr = truncateStr || `...`;
      length = ~~length;
      return str.length > length ? str.slice(0, length) + truncateStr : str;
    },

    /**
     * _s.prune: a more elegant version of truncate
     * prune extra chars, never leaving a half-chopped word.
     * @author github.com/rwz
     */
    prune(str, length, pruneStr) {
      if (str == null) return ``;

      str = String(str); length = ~~length;
      pruneStr = pruneStr != null ? String(pruneStr) : `...`;

      if (str.length <= length) return str;

      var tmpl = function(c) { return c.toUpperCase() !== c.toLowerCase() ? `A` : ` `; },
        template = str.slice(0, length+1).replace(/.(?=\W*\w*$)/g, tmpl); // 'Hello, world' -> 'HellAA AAAAA'

      if (template.slice(template.length-2).match(/\w\w/))
        template = template.replace(/\s*\S+$/, ``);
      else
        template = _s.rtrim(template.slice(0, template.length-1));

      return (template+pruneStr).length > str.length ? str : str.slice(0, template.length)+pruneStr;
    },

    words(str, delimiter) {
      if (_s.isBlank(str)) return [];
      return _s.trim(str, delimiter).split(delimiter || /\s+/);
    },

    pad(str, length, padStr, type) {
      str = str == null ? `` : String(str);
      length = ~~length;

      var padlen = 0;

      if (!padStr)
        padStr = ` `;
      else if (padStr.length > 1)
        padStr = padStr.charAt(0);

      switch (type) {
        case `right`:
          padlen = length - str.length;
          return str + strRepeat(padStr, padlen);
        case `both`:
          padlen = length - str.length;
          return strRepeat(padStr, Math.ceil(padlen/2)) + str
                  + strRepeat(padStr, Math.floor(padlen/2));
        default: // 'left'
          padlen = length - str.length;
          return strRepeat(padStr, padlen) + str;
      }
    },

    lpad(str, length, padStr) {
      return _s.pad(str, length, padStr);
    },

    rpad(str, length, padStr) {
      return _s.pad(str, length, padStr, `right`);
    },

    lrpad(str, length, padStr) {
      return _s.pad(str, length, padStr, `both`);
    },

    sprintf,

    vsprintf(fmt, argv) {
      argv.unshift(fmt);
      return sprintf.apply(null, argv);
    },

    toNumber(str, decimals) {
      if (str == null || str == ``) return 0;
      str = String(str);
      var num = parseNumber(parseNumber(str).toFixed(~~decimals));
      return num === 0 && !str.match(/^0+$/) ? Number.NaN : num;
    },

    numberFormat(number, dec, dsep, tsep) {
      if (isNaN(number) || number == null) return ``;

      number = number.toFixed(~~dec);
      tsep = tsep || `,`;

      var parts = number.split(`.`), fnums = parts[0],
        decimals = parts[1] ? (dsep || `.`) + parts[1] : ``;

      return fnums.replace(/(\d)(?=(?:\d{3})+$)/g, `$1` + tsep) + decimals;
    },

    strRight(str, sep) {
      if (str == null) return ``;
      str = String(str); sep = sep != null ? String(sep) : sep;
      var pos = !sep ? -1 : str.indexOf(sep);
      return ~pos ? str.slice(pos+sep.length, str.length) : str;
    },

    strRightBack(str, sep) {
      if (str == null) return ``;
      str = String(str); sep = sep != null ? String(sep) : sep;
      var pos = !sep ? -1 : str.lastIndexOf(sep);
      return ~pos ? str.slice(pos+sep.length, str.length) : str;
    },

    strLeft(str, sep) {
      if (str == null) return ``;
      str = String(str); sep = sep != null ? String(sep) : sep;
      var pos = !sep ? -1 : str.indexOf(sep);
      return ~pos ? str.slice(0, pos) : str;
    },

    strLeftBack(str, sep) {
      if (str == null) return ``;
      str += ``; sep = sep != null ? ``+sep : sep;
      var pos = str.lastIndexOf(sep);
      return ~pos ? str.slice(0, pos) : str;
    },

    toSentence(array, separator, lastSeparator, serial) {
      separator = separator || `, `;
      lastSeparator = lastSeparator || ` and `;
      var a = array.slice(), lastMember = a.pop();

      if (array.length > 2 && serial) lastSeparator = _s.rtrim(separator) + lastSeparator;

      return a.length ? a.join(separator) + lastSeparator + lastMember : lastMember;
    },

    toSentenceSerial() {
      var args = slice.call(arguments);
      args[3] = true;
      return _s.toSentence.apply(_s, args);
    },

    slugify(str) {
      if (str == null) return ``;

      var from = `ąàáäâãåæćęèéëêìíïîłńòóöôõøùúüûñçżź`,
        to = `aaaaaaaaceeeeeiiiilnoooooouuuunczz`,
        regex = new RegExp(defaultToWhiteSpace(from), `g`);

      str = String(str).toLowerCase().replace(regex, function(c) {
        var index = from.indexOf(c);
        return to.charAt(index) || `-`;
      });

      return _s.dasherize(str.replace(/[^\w\s-]/g, ``));
    },

    surround(str, wrapper) {
      return [wrapper, str, wrapper].join(``);
    },

    quote(str) {
      return _s.surround(str, `"`);
    },

    exports() {
      var result = {};

      for (var prop in this) {
        if (!Object.prototype.hasOwnProperty.call(this, prop) || prop.match(/^(?:include|contains|reverse)$/)) continue;
        result[prop] = this[prop];
      }

      return result;
    },

    repeat(str, qty, separator) {
      if (str == null) return ``;

      qty = ~~qty;

      // using faster implementation if separator is not needed;
      if (separator == null) return strRepeat(String(str), qty);

      // this one is about 300x slower in Google Chrome
      for (var repeat = []; qty > 0; repeat[--qty] = str) {}
      return repeat.join(separator);
    },

    levenshtein(str1, str2) {
      if (str1 == null && str2 == null) return 0;
      if (str1 == null) return String(str2).length;
      if (str2 == null) return String(str1).length;

      str1 = String(str1); str2 = String(str2);

      var current = [], prev, value;

      for (var i = 0; i <= str2.length; i++)
        for (var j = 0; j <= str1.length; j++) {
          if (i && j)
            if (str1.charAt(j - 1) === str2.charAt(i - 1))
              value = prev;
            else
              value = Math.min(current[j], current[j - 1], prev) + 1;
          else
            value = i + j;

          prev = current[j];
          current[j] = value;
        }

      return current.pop();
    },
  };

  // Aliases

  _s.strip = _s.trim;
  _s.lstrip = _s.ltrim;
  _s.rstrip = _s.rtrim;
  _s.center = _s.lrpad;
  _s.rjust = _s.lpad;
  _s.ljust = _s.rpad;
  _s.contains = _s.include;
  _s.q = _s.quote;

  // CommonJS module is defined
  if (typeof exports !== `undefined`) {
    if (typeof module !== `undefined` && module.exports) {
      // Export module
      module.exports = _s;
    }
    exports._s = _s;

  } else if (typeof define === `function` && define.amd) {
    // Register as a named module with AMD.
    define(`underscore.string`, [], function() {
      return _s;
    });

  } else {
    // Integrate with Underscore.js if defined
    // or create our own underscore object.
    root._ = root._ || {};
    root._.string = root._.str = _s;
  }

}).call(this, this, String);

}.call(window));